import { Model } from 'pinia-orm'
import { Num, Str } from 'pinia-orm/decorators'

export default class OrgTeamRole extends Model {
    static entity = 'org-roles'

    static readonly Director = 13

    static readonly Guarantor = 11

    static readonly TechnicalInspector = 12

    @Num(0, { notNullable: true })
    declare id: number
    @Str('', { notNullable: true })
    declare role: string
    @Str(null)
    declare shortcut: string
    @Num(0)
    declare points: number

    get order(): number {
        return this.isDirector
            ? 100
            : (this.isGuarantor
                ? 70
                : (this.isTechnicalInspector ? 50 : 1))
    }

    get isDirector(): boolean {
        return this.id === OrgTeamRole.Director
    }

    get isGuarantor(): boolean {
        return this.id === OrgTeamRole.Guarantor
    }

    get isTechnicalInspector(): boolean {
        return this.id === OrgTeamRole.TechnicalInspector
    }

    get internationalName(): string | null {
        if (this.isDirector)
            return 'Race Director'

        if (this.isGuarantor)
            return 'Event Guarantor'

        if (this.isTechnicalInspector)
            return 'Technical Inspector'

        return null
    }

    static piniaOptions = {
        persist: true,
    }
}
